import isString from 'lodash/isString';
import isPromise from 'is-promise';
import ValidationResult from '../ValidationResult';
import { $l } from '../../locale-context';
export default function customError(value, props, getProp) {
    const customValidator = getProp('customValidator');
    if (typeof customValidator === 'function') {
        const { name, record, form } = props;
        const resultIfPromise = customValidator(value, name, record || form);
        const call = (result) => {
            if (isString(result) || result === false) {
                return new ValidationResult({
                    validationProps: {
                        customValidator,
                    },
                    validationMessage: result || $l('Validator', 'unknown'),
                    value,
                    ruleName: 'customError',
                });
            }
            return true;
        };
        if (isPromise(resultIfPromise)) {
            return resultIfPromise.then(call);
        }
        return call(resultIfPromise);
    }
    return true;
}
